// src/components/map/MapView.jsx
import React from 'react'
import { MapContainer, TileLayer } from 'react-leaflet'
import { useNavigate } from 'react-router-dom' // ✅ ADD THIS
import MapController from './MapController'
import Route from './Route'

const MapView = ({ center, zoom, routes }) => {
  const navigate = useNavigate() // ✅ NEW

  // ✅ When user clicks a route, navigate to details
  const handleRouteClick = (route) => {
    if (route?.id) {
      navigate(`/routes/${route.id}`)
    }
  }

  return (
    <div className="rounded-lg overflow-hidden shadow-xl">
      <div className="h-96 md:h-[600px]">
        <MapContainer
          center={center}
          zoom={zoom}
          className="w-full h-full"
          zoomControl
          style={{ zIndex: 0 }}
        >
          <TileLayer
            attribution="&copy; OpenStreetMap contributors"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <MapController center={center} zoom={zoom} />

          {routes.map((route, idx) => (
            <Route 
              key={route.id} 
              route={route} 
              index={idx}
              onRouteClick={handleRouteClick} // ✅ Pass handler
            />
          ))}
        </MapContainer>
      </div>
    </div>
  )
}

export default MapView
